import React from 'react'
import logo from "../assets/images/logo2.jpeg"

export default function Footer() {
  return (
    <footer className="section-footer bg-primary footer-dark">
    <div className="container">
       <section className="footer-main py-5">
          <div className="row">
             <aside className="col-12 col-sm-12 col-lg-3">
                <article className="me-lg-4">
                   
                 <img  src='..src/assets/images/logo2.jpeg' alt='logo' width="200" height={200} />
                </article>
             </aside>
             <aside className="col-6 col-sm-4 col-lg-2">
                <h6 className="title">HM Store</h6>
                <ul className="list-menu">
                   <li> <a href="#">Nosotros</a></li>
                   <li> <a href="#">Productos</a></li>
                   <li> <a href="#">Categories</a></li>
                   <li> <a href="#">Ofertas</a></li>
                </ul>
             </aside>
             <aside className="col-6 col-sm-4 col-lg-2">
                <h6 className="title">Information</h6>
                <ul className="list-menu">
                   <li> <a href="#">Centro de ayuda</a></li>
                   <li> <a href="#">Formas de Pago</a></li>
                   <li> <a href="#">Política de Garantía y Devoluciones</a></li>
                   <li> <a href="#">Aviso de Privacidad</a></li>
                </ul>
             </aside>
             <aside className="col-6 col-sm-4 col-lg-2">
                <h6 className="title">Soporte</h6>
                <ul className="list-menu">
                   <li> <a href="#"> Envío en 24 horas </a></li>
                   <li> <a href="#"> Vuélvete un Afiliado </a></li>
                   <li> <a href="#"> Trabaja con nosotros </a></li>
                   <li> <a href="#"> Login </a></li>
                </ul>
             </aside>
             <aside className="col-12 col-sm-12 col-lg-3">
                <h6 className="title">NOVEDADES</h6>
                <p>Manténgase en contacto con las últimas actualizaciones sobre nuestros productos y ofertas. </p>
                <form className="mb-3">
                   <div className="input-group"> <input className="form-control" type="text" placeholder="Email" /> <button className="btn btn-light" type="submit"> Join </button> </div>
                   
                </form>
             </aside>
          </div>
       
       </section>
       
       <hr className="my-0" />
       <section className="footer-bottom d-flex justify-content-lg-between">
          <div> <i className="fab fa-lg fa-cc-visa"></i> <i className="fab fa-lg fa-cc-amex"></i> <i className="fab fa-lg fa-cc-mastercard"></i> <i className="fab fa-lg fa-cc-paypal"></i> </div>
       </section>
    </div>
  
 </footer>
  )
}
